// extracted by mini-css-extract-plugin
export default {"background":"ChangeRequestsModal_background__zanCk"};